import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";
import { legalServiceSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/aree/diritto-societario")({
  head: () => seoMeta({
    title: "AI per il diritto societario",
    description: "Statuti, patti parasociali, due diligence M&A, governance e compliance societaria con assistenza AI.",
    path: "/aree/diritto-societario",
  }),
  component: () => (
    <ContentPage
      extraSchemas={[legalServiceSchema({ name: "LexAIPro - AI per il diritto societario", description: "Assistenza AI per statuti, M&A, governance e compliance societaria.", path: "/aree/diritto-societario" })]}
      eyebrow="Aree di pratica"
      title="LexAIPro per il diritto societario"
      lead="Strumenti AI per la pratica societaria: statuti, patti parasociali, due diligence, governance, compliance e operazioni straordinarie."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Aree",path:"/aree/diritto-societario"},{name:"Diritto societario",path:"/aree/diritto-societario"}]}
      sections={[
        { heading: "Casi d'uso", bullets: ["Redazione statuti e patti parasociali","Due diligence M&A","Verbali assembleari e CdA","Compliance D.Lgs. 231/2001"] },
      ]}
      cta={{ label: "Prova gratis", to: "/signup" }}
      heroImage={pickContent(24)}
      updated="2026"
    />
  ),
});
